module.exports = __webpack_public_path__ + "img/safari-step-4.448a82b9.png";